<template>
  <div
    class="resourceActivation div-layout tab-resetStyle"
  >
    <el-tabs
      v-model="actionName"
    >
      <el-tab-pane
        label="自动激活"
        name="automaticActivation"
      >
        <automaticActivation
          v-if="actionName==='automaticActivation'"
          :type-list="typeList"
        />
      </el-tab-pane>
      <el-tab-pane
        label="人工激活"
        name="manualActivation"
      >
        <manualActivation
          v-if="actionName==='manualActivation'"
          :type-list="typeList"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getResourceType } from '@/api/productOperation/financialCenter/resourceActivation.js';
import automaticActivation from './common/automaticActivation';
import manualActivation from './common/manualActivation';
export default {
  components: {
    automaticActivation,
    manualActivation
  },
  data() {
    return {
      actionName: 'automaticActivation',
      typeList: []
    };
  },

  mounted() {
    getResourceType({}).then((res) => {
      console.log(res);
      if (res.code === '0') {
        this.typeList = res.data || [
          { label: '新芽', value: 0 },
          { label: '中教云', value: 1 },
          { label: '赶考状元', value: 2 }
        ];
      } else {
        this.typeList = [
          { label: '新芽', value: 0 },
          { label: '中教云', value: 1 },
          { label: '赶考状元', value: 2 }
        ];
      }
    });
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.resourceActivation {
}
</style>
